import React from 'react';
import { ShieldCheck, BadgeCheck, Clock4, MessageCircle } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

export const TrustBadges = () => {
  const { t } = useLanguage();
  const items = t.trustBadges.items;
  const ICONS = [ShieldCheck, BadgeCheck, Clock4, MessageCircle];

  return (
    <section data-testid="trust-badges" className="bg-cream border-y border-sand-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-6 md:py-8">
        <ul className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {items.map((label, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <li
                key={i}
                data-testid={`trust-badge-${i}`}
                className="flex items-center gap-3 text-ink-700"
              >
                <span className="w-9 h-9 rounded-full bg-sand-100 text-olive-600 flex items-center justify-center shrink-0">
                  <Icon className="w-4.5 h-4.5" strokeWidth={1.4} />
                </span>
                <span className="text-xs md:text-sm leading-tight tracking-wide">
                  {label}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default TrustBadges;
